import { Grid } from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';
import { useAccount } from 'wagmi';

import { useStakingContext } from '../contexts/staking.context';
import { useUserContext } from '../../../context/user.context';

export const Tabs = () => {
  const { selectedTab, setSelectedTab, fetchWithdrawList, updateVaults } =
    useStakingContext();
  const { isLoggedIn } = useUserContext();
  const { address } = useAccount();

  return (
    <Grid
      item
      className=""
      lg={12}
      md={12}
      sm={12}
      xs={12}
      display={'flex'}
      flexDirection={'row'}
      alignItems={'flex-start'}
      justifyContent={'flex-start'}
    >
      <Button
        className="mr-2"
        sx={{
          height: '40px',
          width: 'auto',
          background:
            selectedTab === 'vaults'
              ? 'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)'
              : 'transparent',
          border: 0.75,
          borderColor: '#FC9D4B',
          borderRadius: '25px',
          color: '#FFFFFF',
          fontWeight: 'semibold',
          fontFamily: 'PoppinsRegular',
          fontSize: {
            xs: '16px',
            sm: '16px',
            md: '18px',
            lg: '18px',
          },
          padding: {
            xs: '15px',
            sm: '12px',
            md: '15px',
          },
          '&:hover': {
            background:
              'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
            boxShadow: '0px 0px 13px 1px #FC9D4B',
          },
          textTransform: 'none',
        }}
        onClick={() => {
          {
            if (isLoggedIn && address) updateVaults();
            setSelectedTab('vaults');
          }
        }}
      >
        Vaults
      </Button>
      <Button
        className="mx-2"
        sx={{
          height: '40px',
          width: 'auto',
          background:
            selectedTab === 'withdraw'
              ? 'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)'
              : 'transparent',
          border: 0.75,
          borderColor: '#FC9D4B',
          borderRadius: '25px',
          color: '#FFFFFF',
          fontWeight: 'semibold',
          fontFamily: 'PoppinsRegular',
          fontSize: {
            xs: '16px', // For extra small screens (mobile)
            sm: '16px', // For small screens (tablets)
            md: '18px', // For medium screens
            lg: '18px', // For large screens
          },
          padding: {
            xs: '10px', // For extra small screens
            sm: '12px', // For small screens
            md: '15px', // For medium screens
          },
          '&:hover': {
            background:
              'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
            boxShadow: '0px 0px 13px 1px #FC9D4B',
          },
          textTransform: 'none',
        }}
        onClick={() => {
          if (isLoggedIn && address) fetchWithdrawList();
          setSelectedTab('withdraw');
        }}
      >
        Withdraw
      </Button>
      <Button
        className="mx-2"
        sx={{
          height: '40px',
          width: 'auto',
          background:
            selectedTab === 'history'
              ? 'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)'
              : 'transparent',
          border: 0.75,
          borderColor: '#FC9D4B',
          borderRadius: '25px',
          color: '#FFFFFF',
          fontWeight: 'semibold',
          fontFamily: 'PoppinsRegular',
          fontSize: {
            xs: '16px', // For extra small screens (mobile)
            sm: '16px', // For small screens (tablets)
            md: '18px', // For medium screens
            lg: '18px', // For large screens
          },
          padding: {
            xs: '10px', // For extra small screens
            sm: '12px', // For small screens
            md: '15px', // For medium screens
          },
          '&:hover': {
            background:
              'linear-gradient(90deg, rgba(241, 215, 75, 0.8) 0%, rgba(221, 113, 42, 0.8) 65.9%)',
            boxShadow: '0px 0px 13px 1px #FC9D4B',
          },
          textTransform: 'none',
        }}
        onClick={() => {
          if (isLoggedIn && address) fetchWithdrawList();
          setSelectedTab('history');
        }}
      >
        History
      </Button>
    </Grid>
  );
};
